import React from 'react'

const MaterialTestingServicesAsphalt = () => {
  return (
    <section className="services-details pt-120 pb-120">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          {/*Start Services Details Content*/}
          <div className="col-xl-12 col-lg-12">
            <div className="services-details__content">
              <h3>Material Testing Services – Asphalt </h3>
              <p className="mb-30">
                Asphalt is a critical material for roads, pavements, and airport
                runways, where durability, performance, and safety are
                paramount. Asphalt Material Testing must verify that asphalt
                mixtures and pavements meet design specifications and perform
                reliably under traffic, environmental, and climatic conditions.
              </p>
              <p className="mb-30">
                The need for standardized asphalt testing emerged from failures
                such as rutting, cracking, stripping, and premature pavement
                deterioration, caused by improper mix design, inadequate
                compaction, or poor material choice. International standards
                ensure that asphalt quality, mechanical performance, and
                long-term durability can be consistently assessed and verified.
              </p>
              <p className="mb-30">
                Without proper asphalt testing, transportation infrastructure
                projects may face costly maintenance, reduced service life, and
                safety hazards.
              </p>
              <div className="content mt-40">
                <div className="text">
                  <h3 className="mb-4">Purpose and Engineering Importance</h3>
                  <p className="mb-30">
                    The primary objective of asphalt material testing is to
                    provide right, quantitative data that guides pavement
                    design, quality control, and construction decisions.
                    Benefits to clients include:
                  </p>
                  <ul className="project-list">
                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Verification of asphalt mix design and composition
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Assessment of material properties including stability,
                      binder content, and gradation
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Monitoring compaction and density during construction
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Evaluation of long-term durability and resistance to
                      traffic and weather
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Ensuring compliance with project specifications and
                      regulatory requirements
                    </li>
                  </ul>
                  <p className="mb-30">
                    Effective asphalt testing reduces the risk of pavement
                    failures, optimizes maintenance costs, and enhances the
                    performance of road infrastructure.
                  </p>
                </div>
              </div>
              <div className="service-nr-list">
                <h3 className="mb-5">Our Services </h3>
                <p className="mb-30">
                  Pak Arab Inspection LTD. CO Company provides comprehensive asphalt
                  testing services for roads, highways, airports, and industrial
                  pavements. Our experienced engineers and technicians conduct
                  laboratory and field tests using standardized procedures to
                  ensure the highest level of accuracy and reliability.
                </p>
                <p className="mb-30">
                  We support design verification, construction quality control,
                  and performance assessment, enabling clients to make informed
                  engineering decisions.
                </p>
              </div>
              <div className="service-nr-list">
                <h3 className="">Scope </h3>
                <h4 className="">
                  Our Asphalt Material Testing services typically include:
                </h4>
                <div className="row">
                  <div className="col-lg-4">
                    <h5>Laboratory Testing</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Gradation Analysis of
                        Aggregates.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Bitumen Content and
                        Penetration Tests.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Marshall Mix Design and
                        Stability Testing.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Bulk Density and Specific
                        Gravity.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Moisture Susceptibility
                        and Stripping Resistance.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Rutting, Flow, and
                        Deformation Analysis.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Field Testing</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Asphalt Core Sampling.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Pavement Density and
                        Compaction Verification.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Surface Texture and
                        Thickness Measurement.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Temperature Monitoring
                        During Laying and Compaction.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Specialized Tests </h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Indirect Tensile
                        Strength.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Dynamic Modulus and
                        Fatigue Testing.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Rut Depth Measurement and
                        Skid Resistance Evaluation.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MaterialTestingServicesAsphalt